<div class="container">
  <div class="row" >
    <div class="col-md-12 col-sm-12 scroll-table" >
      <table class="table" style="margin-top: 12px;">
        <thead>
          <tr class="font-weight-bold">
            <th scope="col">Número</th>
            <th scope="col">Veículo</th>
            <th class="text-righy">Data e hora de saída</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let roteiro of roteirosCrossdocking" class="hover-pedido">
            <td >{{ roteiro.roteiro }} </td>
            <td> {{ roteiro.veiculo }} </td>
            <td class="text-righy"> {{ roteiro.PrevisaoSaida.replace("Z", " ") | date: 'dd/MM/yyyy' }} <span class="sub-titulo">às</span> {{ roteiro.PrevisaoSaida.replace("Z", " ") | date: 'hh:mm' }} </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
